import script from "./WorkbookFilterForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkbookFilterForm.vue?vue&type=script&setup=true&lang=ts"

import "./WorkbookFilterForm.vue?vue&type=style&index=0&id=c59ac868&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c59ac868"]])

export default __exports__